export const locationApiQueryKeys = {
  base: ['location'],
  orgLocations: (orgId: string) => [...locationApiQueryKeys.base, 'org-locations', orgId],
  userLocations: (userId?: string) => [...locationApiQueryKeys.base, 'user-locations', userId],
};
